// utils/serverError.ts
//
// Backend error messages are English-only. Show them verbatim only when the
// UI is in English; every other language gets the translated fallback, so a
// non-English screen never shows an English sentence.
import i18n from "../i18n";
import { getAppLanguage } from "./appLanguage";
import { getUpgradePopupText } from "./upgradePopupText";

export const serverErrorMessage = (error: any, fallbackKey: string): string => {
  // Free Companion Talk limit: always in the user's own language.
  if (error?.response?.data?.code === "TALK_LIMIT_REACHED") {
    return getUpgradePopupText(getAppLanguage()).hard;
  }
  if (error?.response?.data?.limitReached && typeof error?.response?.data?.message === "string") {
    return error.response.data.message;
  }
  const message: unknown =
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message;
  return typeof message === "string" && message && getAppLanguage() === "en"
    ? message
    : i18n.t(fallbackKey);
};
